
<app-header ></app-header>
<div id="main-layout" [class.layout-sidemenu]="isSidemenuOpen" [class.sidenav-toggled]="!isSidemenuOpen">
    
    <div class="layout-sidemenu__nav"  *ngIf="isloggedIn && isSidemenuOpen">
        <app-sidemenu ></app-sidemenu>
    </div>
    <main class="layout-sidemenu__content">
        <p-toast></p-toast>
        <router-outlet></router-outlet>
        
    </main>
</div>